import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
import {
    Checkbox,
    FormControlLabel,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import Axios from 'axios';
import {
    getListeProduit,
    getTypeProduit,
    getListePierre,
    getTypeTarif,
    modifTarifProd,
} from '../../actions'; // Vérifie que les imports sont bien centralisés dans index.js
import { apiATC, localization, meekroDB } from '../../config';
import { getPierre } from '../../selectors/pierre';

const useStyles = makeStyles({
    table: {},
});

const initialFormState = {
    id: '',
    ref: null,
    description: '',
    facon: '',
    fsf: '',
    poids: '',
    serti: '',
    divers: '',
    typeTarif: null,
    image: 'no_pic.jpg',
};

const initialPierreState = {
    pierre: null,
    qte: '',
    poidsPierre: '',
    centre: false,
    pierreExist: false,
};

const Centre = ({
    getListeProduit,
    listeRef,
    listeProduit,
    getTypeProduit,
    listePierre,
    getListePierre,
    listeTypeTarif,
    getTypeTarif,
    modifTarifProd,
}) => {
    const [form, setForm] = useState(initialFormState);
    const [rows, setRows] = useState([]);
    const [pierreState, setPierreState] = useState(initialPierreState);

    const classes = useStyles();

    // Chargement des données
    useEffect(() => {
        getListeProduit();
        getTypeProduit();
        getTypeTarif();
        getListePierre();
    }, [getListeProduit, getTypeProduit, getTypeTarif, getListePierre]);

    // Helpers
    const resetForm = () => setForm(initialFormState);
    const resetPierre = () => setPierreState(initialPierreState);

    const returnList = useCallback(() => {
        return Array.isArray(listeProduit) ? listeProduit : [];
    }, [listeProduit]);

    // Sélection d'une ligne produit
    const handleClick = (_, rowData) => {
        const refSelected = Object.values(listeRef).find(r => r.id_cv === rowData.id_cv);
        const typeTarif = Object.values(listeTypeTarif).find(r => r.id === rowData.id_tarif_produit);

        setForm({
            id: rowData.id_centre,
            ref: refSelected || null,
            description: rowData.description,
            facon: rowData.plus_mo,
            fsf: rowData.plus_fonte,
            poids: rowData.plus_poids,
            serti: rowData.plus_serti,
            divers: rowData.prix_divers,
            typeTarif: typeTarif || null,
            image: rowData.image || 'no_pic.jpg',
        });

        Axios.get(`${apiATC}/pierre/centre_pierre.php?id=${rowData.id_centre}`)
            .then(response => {
                setRows(response.data);
                resetPierre();
            })
            .catch(console.log);
    };

    // Création ou modification produit
    const handleSave = () => {
        const { id, ref, description, facon, fsf, poids, serti, divers, typeTarif } = form;
        if (!id || !ref) return;

        const data = {
            table: 'centre',
            primaryKey: 'id_centre',
            id,
            id_cv: ref.id_cv,
            ref: description,
            plus_mo: facon,
            plus_fonte: fsf,
            plus_poids: poids,
            plus_serti: serti,
            prix_divers: divers,
        };

        Axios.post(`${apiATC}/general.php?action=modifier`, data)
            .then(() => {
                const produit = {
                    table: 'produit',
                    primaryKey: 'id_centre',
                    id,
                    id_tarif_produit: typeTarif?.id,
                };
                Axios.post(`${apiATC}/general.php?action=modifier`, produit)
                    .then(() => {
                        modifTarifProd(id);
                        getListeProduit();
                    })
                    .catch(console.log);
            })
            .catch(console.log);
    };

    const handleCreate = () => {
        const { ref, description, facon, fsf, poids, serti, divers, typeTarif } = form;
        if (!ref || !description) return alert('Veuillez renseigner tous les champs nécessaires');
        const exist = Object.values(listeProduit).find(p => p.ref === ref.ref && p.description === description);
        if (exist) return alert('Combinaison ref et description déjà existante');
        if (!window.confirm('Voulez-vous créer un nouveau produit ?')) return;

        const data = {
            table: 'centre',
            ref: description,
            plus_mo: facon,
            plus_fonte: fsf,
            plus_poids: poids,
            plus_serti: serti,
            prix_divers: divers,
            id_cv: ref.id_cv,
        };

        Axios.post(`${apiATC}/general.php?action=ajouter`, data)
            .then(response => {
                const insertId = response.data;
                const prod = {
                    table: 'produit',
                    id_centre: insertId,
                    id_tarif_produit: typeTarif?.id,
                };
                Axios.post(`${apiATC}/general.php?action=ajouter`, prod)
                    .then(() => {
                        rows.forEach(p => {
                            const centrePierre = {
                                table: 'centre_pierres',
                                id_centre: insertId,
                                id_pierre: p.id_tarif,
                                qte: p.qte,
                                pds_r: p.pds_r,
                                centre: p.centre,
                            };
                            Axios.post(`${apiATC}/general.php?action=ajouter`, centrePierre)
                                .then(() => {
                                    Axios.get(`${meekroDB}/produit/modif_tarif_produit.php?centres=${insertId}`)
                                        .then(() => {
                                            modifTarifProd(insertId);
                                            getListeProduit();
                                        })
                                        .catch(console.log);
                                })
                                .catch(console.log);
                        });
                    })
                    .catch(console.log);
            })
            .catch(console.log);
    };

    // Gestion des champs
    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const changeRef = values => {
        if (!values) {
            resetForm();
            resetPierre();
            setRows([]);
        } else {
            setForm(prev => ({
                ...prev,
                ref: values,
                facon: values.facon,
                fsf: values.facon_fonte,
                poids: values.poids_metal,
                serti: values.serti_min,
            }));
        }
    };

    // Pierre
    const selectPierre = data => {
        const pierreSelect = Object.values(listePierre).find(p => p.id_tarif === data.id_tarif);
        setPierreState({
            pierre: pierreSelect || null,
            qte: data.qte,
            poidsPierre: data.pds_r,
            centre: !!data.centre,
            pierreExist: true,
        });
    };

    const handleSelectPierre = values => {
        const exist = rows.find(p => p.id_tarif === values?.id_tarif);
        setPierreState(prev => ({
            ...prev,
            pierre: values,
            pierreExist: !!exist,
        }));
    };

    const handleCreatePierre = () => {
        const { id } = form;
        const { pierre, qte, poidsPierre, centre } = pierreState;
        if (!id || !pierre || !qte || !poidsPierre) return alert('Veuillez renseigner tous les champs nécessaires *');
        const data = {
            id_centre: id,
            id_pierre: pierre.id_tarif,
            qte,
            pds_r: poidsPierre,
            centre: centre ? 1 : 0,
        };
        Axios.post(`${apiATC}/pierre/centre_pierre.php?action=inserer`, data)
            .then(() => {
                modifTarifProd(id);
                refreshDetailPierre();
            })
            .catch(console.log);
    };

    const handleSavePierre = () => {
        const { id } = form;
        const { pierre, qte, poidsPierre, centre } = pierreState;
        const data = {
            id_centre: id,
            id_pierre: pierre.id_tarif,
            qte,
            pds_r: poidsPierre,
            centre: centre ? 1 : 0,
        };
        Axios.post(`${apiATC}/pierre/centre_pierre.php?action=modifier`, data)
            .then(() => {
                modifTarifProd(id);
                refreshDetailPierre(false);
            })
            .catch(console.log);
    };

    const handleDeletePierre = () => {
        const { id } = form;
        const { pierre } = pierreState;
        const data = {
            id_centre: id,
            id_pierre: pierre.id_tarif,
        };
        Axios.post(`${apiATC}/pierre/centre_pierre.php?action=supprimer`, data)
            .then(() => {
                modifTarifProd(id);
                refreshDetailPierre();
                resetPierre();
            })
            .catch(console.log);
    };

    const refreshDetailPierre = (reset = true) => {
        Axios.get(`${apiATC}/pierre/centre_pierre.php?id=${form.id}`)
            .then(response => {
                setRows(response.data);
                if (reset) resetPierre();
            })
            .catch(console.log);
    };

    const getBackgroundColor = row =>
        pierreState.pierre && row.id_tarif === pierreState.pierre.id_tarif ? '#AED1FF' : '';

    // Render
    return (
        <div className="container-fluid">
            <div className="row">
                {/* Table produits */}
                <div className="col-sm">
                    <MaterialTable
                        style={{ fontSize: 12, zIndex: 0 }}
                        columns={[
                            { title: 'Type', field: 'typeProd' },
                            { title: 'Ref', field: 'ref' },
                            { title: 'Description', field: 'description' },
                            { title: 'Facon', field: 'plus_mo' },
                            { title: 'FSF', field: 'plus_fonte' },
                            { title: 'Poids', field: 'plus_poids' },
                            { title: 'Serti', field: 'plus_serti' },
                            { title: 'Divers', field: 'prix_divers' },
                            { title: 'Tarif', field: 'descTarif' },
                        ]}
                        title={<div style={{ width: 170, fontSize: 16, display: 'flex' }}>Centre</div>}
                        data={returnList()}
                        options={{
                            pageSize: 10,
                            rowStyle: rowData => ({
                                backgroundColor: form.id === rowData.id_centre ? '#AED1FF' : '',
                            }),
                        }}
                        onRowClick={handleClick}
                        localization={localization}
                    />
                </div>
                {/* Formulaire produit */}
                <div className="col-sm">
                    <form>
                        <div className="form-group">
                            <Autocomplete
                                value={form.ref}
                                options={listeRef}
                                getOptionLabel={option => option.ref}
                                onChange={(_, values) => changeRef(values)}
                                getOptionSelected={(option, value) => option.id_cv === value?.id_cv}
                                autoHighlight
                                autoComplete
                                clearOnEscape
                                fullWidth
                                renderInput={params => (
                                    <TextField required autoFocus {...params} label="Ref" variant="outlined" />
                                )}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Description"
                                variant="outlined"
                                required
                                fullWidth
                                value={form.description}
                                onChange={e => handleChange('description', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Facon"
                                variant="outlined"
                                fullWidth
                                value={form.facon}
                                onChange={e => handleChange('facon', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Facon sur Fonte"
                                variant="outlined"
                                fullWidth
                                value={form.fsf}
                                onChange={e => handleChange('fsf', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Poids"
                                variant="outlined"
                                fullWidth
                                value={form.poids}
                                onChange={e => handleChange('poids', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Serti"
                                variant="outlined"
                                fullWidth
                                value={form.serti}
                                onChange={e => handleChange('serti', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Divers"
                                variant="outlined"
                                fullWidth
                                value={form.divers}
                                onChange={e => handleChange('divers', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <Autocomplete
                                value={form.typeTarif}
                                options={listeTypeTarif}
                                getOptionLabel={option => option.description}
                                onChange={(_, values) => handleChange('typeTarif', values)}
                                getOptionSelected={(option, value) => option.id === value?.id}
                                autoHighlight
                                autoComplete
                                clearOnEscape
                                fullWidth
                                renderInput={params => (
                                    <TextField {...params} label="Type Tarif" variant="outlined" />
                                )}
                            />
                        </div>
                        <div className="form-group">
                            <button type="button" className="btn btn-link btn-sm" onClick={handleCreate}>
                                Créer
                            </button>
                            <button
                                type="button"
                                className="btn btn-link btn-sm"
                                onClick={handleSave}
                                disabled={!form.id}
                            >
                                Enregistrer
                            </button>
                        </div>
                    </form>
                </div>
                {/* Table Pierre */}
                <div className="col-sm">
                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Qte</TableCell>
                                <TableCell align="right">Type</TableCell>
                                <TableCell align="right">Forme</TableCell>
                                <TableCell align="right">PoidsU</TableCell>
                                <TableCell align="right">Dimension</TableCell>
                                <TableCell align="right">Poids</TableCell>
                                <TableCell align="right">Qualité</TableCell>
                                <TableCell align="right">Prix/Ct</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map(row => (
                                <TableRow hover key={row.id_pierre} onClick={() => selectPierre(row)}>
                                    {[
                                        row.qte,
                                        row.type,
                                        row.laforme,
                                        row.pds_u,
                                        row.ladim,
                                        row.pds_r,
                                        row.laqual,
                                        row.prix,
                                    ].map((cell, idx) => (
                                        <TableCell
                                            key={idx}
                                            style={{
                                                backgroundColor: getBackgroundColor(row),
                                                color: row.centre === 1 ? 'red' : '',
                                            }}
                                            align={idx === 0 ? 'left' : 'right'}
                                        >
                                            {cell}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <div className="form-group" style={{ paddingTop: 20 }}>
                        <Autocomplete
                            value={pierreState.pierre}
                            options={listePierre}
                            getOptionLabel={option => option.descriptionPierre}
                            onChange={(_, values) => handleSelectPierre(values)}
                            getOptionSelected={(option, value) => option.id_tarif === value?.id_tarif}
                            autoHighlight
                            autoComplete
                            clearOnEscape
                            fullWidth
                            renderInput={params => (
                                <TextField required autoFocus {...params} label="Pierre" variant="outlined" size="small" />
                            )}
                        />
                    </div>
                    <div className="row">
                        <div className="col-sm">
                            <div className="form-group">
                                <TextField
                                    label="Qte"
                                    variant="outlined"
                                    value={pierreState.qte}
                                    onChange={e => setPierreState(prev => ({ ...prev, qte: e.target.value }))}
                                    size="small"
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm">
                            <div className="form-group">
                                <TextField
                                    label="Poids"
                                    variant="outlined"
                                    value={pierreState.poidsPierre}
                                    onChange={e => setPierreState(prev => ({ ...prev, poidsPierre: e.target.value }))}
                                    size="small"
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm">
                            <div className="form-group">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={pierreState.centre}
                                            onChange={e => setPierreState(prev => ({ ...prev, centre: e.target.checked }))}
                                            size="small"
                                            color="primary"
                                        />
                                    }
                                    label="Centre"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <button
                            type="button"
                            className="btn btn-link btn-sm"
                            onClick={handleCreatePierre}
                            disabled={pierreState.pierreExist}
                        >
                            Ajouter
                        </button>
                        <button
                            type="button"
                            className="btn btn-link btn-sm"
                            onClick={handleSavePierre}
                            disabled={!pierreState.pierreExist}
                        >
                            Enregistrer
                        </button>
                        <button
                            type="button"
                            className="btn btn-link btn-sm"
                            onClick={handleDeletePierre}
                            disabled={!pierreState.pierreExist}
                        >
                            Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    listeRef: state.produit.listeReference,
    listeTypeProd: state.generalData.listeTypeProduit,
    listeProduit: state.produit.listeProduit,
    listePierre: getPierre(state),
    listeTypeTarif: state.generalData.listeTypeTarif,
});

const mapDispatchToProps = {
    getListeProduit,
    getTypeProduit,
    getListePierre,
    getTypeTarif,
    modifTarifProd,
};

export default connect(mapStateToProps, mapDispatchToProps)(Centre);